var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mainGray",attrs:{"id":"footer"}},[_c('div',[_c('p',[_c('small',[_vm._v(" Copyright © 2018 FK Skin&Hair. All rights reserved. "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn","target":"_blank"}},[_vm._v("京ICP备19037287号")])])])])])
}]

export { render, staticRenderFns }